import React, { useEffect, useState } from "react";
import { Toast, subscribe, dismissToast } from "./toast";

/**
 * Renders the active toasts in a fixed stack. Mount once near the app root.
 */
export default function ToastContainer() {
  const [toasts, setToasts] = useState<Toast[]>([]);
  useEffect(() => subscribe(setToasts), []);

  if (toasts.length === 0) return null;

  return (
    <div style={s.wrap} aria-live="polite" role="status">
      {toasts.map((t) => (
        <div key={t.id} style={{ ...s.toast, ...typeStyle[t.type] }}>
          <span style={s.msg}>{t.message}</span>
          <button style={s.close} aria-label="Dismiss" onClick={() => dismissToast(t.id)}>
            ×
          </button>
        </div>
      ))}
    </div>
  );
}

const typeStyle: Record<Toast["type"], React.CSSProperties> = {
  error: { background: "#c53030" },
  info: { background: "#2b6cb0" },
  success: { background: "#2f855a" },
};

const s: Record<string, React.CSSProperties> = {
  wrap: {
    position: "fixed", top: 16, right: 16, zIndex: 9999,
    display: "flex", flexDirection: "column", gap: 8, maxWidth: 380,
  },
  toast: {
    display: "flex", alignItems: "flex-start", gap: 12,
    color: "#fff", padding: "12px 14px", borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0,0,0,0.18)", fontSize: 14, lineHeight: 1.4,
  },
  msg: { flex: 1 },
  close: {
    background: "transparent", border: "none", color: "#fff",
    fontSize: 18, lineHeight: 1, cursor: "pointer", padding: 0, opacity: 0.85,
  },
};
